import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { CenteredSpinner } from '../../components/ui/Spinner';
import { getContact } from './api';
import { ContactForm } from './ContactForm';

export function ContactEdit() {
  const { id } = useParams<{ id: string }>();
  const contact = useQuery({
    queryKey: ['contact', id],
    queryFn: () => getContact(id!),
    enabled: !!id,
  });

  if (contact.isLoading) return <CenteredSpinner />;
  if (contact.error || !contact.data) {
    return (
      <div className="text-red-600 text-sm">
        Failed to load contact: {(contact.error as Error | undefined)?.message ?? 'not found'}
      </div>
    );
  }
  return <ContactForm mode={{ kind: 'edit', contact: contact.data }} />;
}
